/**
 * Handles back to top button
 * @module toggleReveal
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'toggleReveal';
export const DEFAULTS = {

};
const makeDisableFocus = (toggleContainer, toggleButton) => () => {
  toggleContainer.find('a').not(toggleButton).attr('tabindex',-1);
}

const makeEnableFocus = (toggleContainer, toggleButton) => () => {
  toggleContainer.find('a')
    .not(toggleButton)
    .attr('tabindex', 0)
    .attr('aria-hidden', false)
    .focus({preventScroll:true});
}

const updateButtonCopy = (toggleButton) => {
  const currentText = toggleButton.find('.action-button__copy').text();
  const newToggleText = toggleButton.data('close-copy');
  toggleButton.data('close-copy', currentText).find('.action-button__copy').text(newToggleText);
}

const makeHandleReveal = (toggleButton, toggleContainer, disableFocus, enableFocus) => () => {
  $('.js-similar-items').css({
    'height': 'initial',
    'padding-bottom': 'initial',
  })
  toggleContainer.toggleClass('active');
  const redirectUrl = toggleButton.data('url');
  updateButtonCopy(toggleButton);

  if (toggleContainer.hasClass('active')) {
    // Check if the slidedown button has a specific class and hide it
    if (toggleButton.hasClass('js-slidedown--toggle-display')) {
      toggleButton.hide();
    }

    enableFocus();

    if (redirectUrl) {
      const anchor = $('<a>', {
        href: redirectUrl,
        class: toggleButton.attr('class'),
        html: toggleButton.html(),
      });

      toggleButton.replaceWith(anchor);
    }
  } else {
    if(redirectUrl) {
      if(toggleButton.prop("tagName").toLowerCase() === 'button') {
        let btnURL = `window.location = "${redirectUrl}"`;
        toggleButton.attr('onClick', btnURL).trigger('click');
      } else { // assumes it's an anchor tag
        toggleButton.attr('href', redirectUrl);
        toggleContainer.addClass('active');
      }
    }
    disableFocus();
  }
}


export default function toggleReveal(el) {
  const toggleButton = $(el);
  const toggleContainer = $(toggleButton.data('containerSelector'));
  const disableFocus = makeDisableFocus(toggleContainer, toggleButton);
  const enableFocus = makeEnableFocus(toggleContainer, toggleButton);
  const handleReveal = makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus);

  disableFocus();
  toggleButton.on('click', handleReveal);

}

registerJQueryPlugin(PLUGIN_NAME, toggleReveal);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-reveal.js